import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory, NavLink } from "react-router-dom";
import PurchaseOrderPrint from "./PurchaseOrderPrint";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import { useReactToPrint } from "react-to-print";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from 'react-icons/md';

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const GoodsReceivedNoteHistory = () => {
    const { t } = useTranslation();
    //getting context values here
    let {
      //common
      loading,
      setLoading,

    } = useContext(SettingsContext);

    const { getSupplier, supplierForSearch } = useContext(UserContext)
  
    let {

      //goods recieve
      goodReceiveList,
      setGoodReceiveList,
      goodReceiveListForSearch,
      setGoodReceiveListForSearch,
      setPaginatedGoodsRecieveNotes,
      branchForListSearch,
      //pagination
      dataPaginating,
    } = useContext(RestaurantContext);
  
    // States hook here
  
    //search result
    let [searchedSupplier, setSearchedSupplier] = useState({
      list: null,
      searched: false,
    });
  
    //useEffect == componentDidMount
    useEffect(() => {
      if(!supplierForSearch){
        getSupplier();
      }
    }, []);
  
    //search goods here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0) {
        setSearchedSupplier({ ...searchedSupplier, searched: false });
      } else {
        let searchedList = goodReceiveListForSearch.filter((item) => {
          //name
          let lowerCaseItemSupplierName = item.supplier_name.toLowerCase();
          //branch
          let lowerCaseBranch = item.branch_name.toLowerCase();
          //email
          let lowerCaseItemInvoice = item.document_identity !== null && item.document_identity.toLowerCase();
  
          return (
            lowerCaseItemSupplierName.includes(searchInput) ||
            lowerCaseItemInvoice.includes(searchInput) || 
            lowerCaseBranch.includes(searchInput)
          );
        });
        setSearchedSupplier({
          ...searchedSupplier,
          list: searchedList,
          searched: true,
        });
      }
    };
  
    //delete confirmation modal of goods note
    const handleDeleteConfirmation = (id) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">{_t(t("You want to delete this?"))}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handleDeletePurchase(id);
                    onClose();
                  }}
                >
                  {_t(t("Yes, delete it!"))}
                </button>
                <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        },
      });
    };
  
    //delete goods here
    const handleDeletePurchase = (id) => {
      setLoading(true);
      const url = BASE_URL + `/settings/goods-received-note/${id}`;
      return axios
        .delete(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGoodReceiveList(res.data[0]);
          setGoodReceiveListForSearch(res.data[1]);
          setSearchedSupplier({
            ...searchedSupplier,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Goods Note has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    };

    const handlePostApi = (id) =>{
      setLoading(true);
      const url = BASE_URL + `/settings/mark-is-post-grn`;
      const formData = {
        id: id,
        status: 1
      }
      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setGoodReceiveList(res.data[0]);
          setGoodReceiveListForSearch(res.data[1]);
          setSearchedSupplier({
            ...searchedSupplier,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Goods received note has been post"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }).catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    }

    //print bills states and function
    const [newRow,setNewRow]=useState([]);
    let [goodsNoteView, setGoodsNoteView] = useState({
      date:null,
      doc_id: null,
      supplier:null,
      branch: '',
      remarks: '',
      purchase_order : null,
      total_amount:'',
      net_amount: "",
      total_discount: "",
      total_tax: ""
    });
    const componentRef = useRef();
    const handleOnlyPrint = useReactToPrint({
      content: () => componentRef.current,
      pageStyle: "@page { margin: 15px }"
    });
    const handleGetPrintData = async(id) => {
      const url = BASE_URL + "/settings/goods-received-note/" + parseInt(id);
      setLoading(true)
      try {
        const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data && res.data.goods_received_note_detail){
          let purchaseDate = new Date(res.data.document_date);
          let suplier = supplierForSearch?.find(item => item?.id === res.data.supplier_id);
          const branch = branchForListSearch[res.data.branch_id]          
          setGoodsNoteView({
            ...goodsNoteView,
            date: purchaseDate,
            branch,
            supplier: suplier,
            doc_id: res.data.document_identity,
            remarks: res.data.desc,
            purchase_order: {document_identity:res.ref_document_identity},
            total_amount: res.data.total_amount,
            net_amount: res.data.net_amount,
            total_discount: res.data.total_discount,
            total_tax: res.data.total_tax
          })
          setNewRow([...res.data.goods_received_note_detail]);
          setLoading(false)
          setTimeout(() => {
            handleOnlyPrint();          
          }, 0);
        }
      } catch(error) {
        setLoading(false)
        console.log("error==>",error)
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }
  
  return (
    <>
    <Helmet>
      <title>{_t(t("Ingredient Goods Note"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div className="fk-scroll--pos-table-menu" data-simplebar>
                <div className="t-pl-15 t-pr-15">
                  {/* Loading effect */}
                  {/* {newSupplier.uploading === true || loading === true ? (
                    tableLoading()
                  ) : ( */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading || dataPaginating}/>
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!searchedSupplier.searched
                                  ? _t(t("GRN List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center">
                            {/* Search customer */}
                            <div className="col-md-9 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-left"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary rounded-right"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            {/* Add customer modal trigger button */}
                            <div className="col-md-3 text-md-right">
                              <NavLink
                                to="/dashboard/manage/stock/goods-received-note-dept-add"
                                className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                              >
                                {_t(t("add new"))}
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="">
                        <table className="table table-bordered table-hover min-table-height">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("GRN #"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("GRN Date"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Branch"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Supplier/Vendor"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Total"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Remarks"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Status"))}
                              </th>
                             
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Created Date"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!searchedSupplier.searched
                              ? [
                                goodReceiveList && [
                                  goodReceiveList.data?.length ===
                                    0 ? (
                                    <tr className="align-middle">
                                      <td
                                        scope="row"
                                        colSpan="7"
                                        className="xsm-text align-middle text-center"
                                      >
                                        {_t(t("No data available"))}
                                      </td>
                                    </tr>
                                  ) : (
                                    Array.isArray(goodReceiveList.data) && goodReceiveList.data.map(
                                      (item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (goodReceiveList.current_page -
                                                  1) *
                                                  goodReceiveList.per_page}
                                            </th>
                                            
                                            <td className="xsm-text align-middle text-center">
                                              {item.document_identity}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.document_date}
                                              </Moment>
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.branch_name}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.supplier_name}
                                            </td>
                                            
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {currencySymbolLeft()}
                                              {formatPrice(item.net_amount)}
                                              {currencySymbolRight()}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.desc}
                                            </td>

                                            <td className="xsm-text text-capitalize font-weight-md align-middle text-center">
                                              {item.status === "Open" ? <span className="text-success">{item.status}</span> : (item.status === "Closed" ? <span className="text-danger">{item.status}</span> : <>{item.status}</>)}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <div className="d-flex justify-content-center">  
                                                <button
                                                  className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={()=>handleGetPrintData(item.id)}
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>  
                                                {
                                                item.is_post !== 1 ? 
                                                  <>                                                
                                                  <NavLink
                                                    className="btn btn-primary ml-2 rounded-sm"
                                                    to={`/dashboard/manage/stock/goods-received-note-dept-edit/${item.id}`}
                                                    style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                  >
                                                    <div className="d-flex align-items-center justify-content-center">
                                                      <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                    </div>
                                                  </NavLink>
                                                  <button
                                                  className="btn btn-danger ml-2 rounded-sm del-btn"
                                                  onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                  >                                                    
                                                    <MdDelete className="del-icon" />                                                    
                                                  </button>
                                                  <button
                                                    className="btn btn-dark ml-2 rounded-sm del-btn"
                                                    title="Post purchase" 
                                                    disabled={loading}  
                                                    style={{padding:"1px 0px 0px 1px"}}                                               
                                                    onClick={()=>handlePostApi(item.id)}
                                                  >
                                                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                  </button> </> : ""
                                                }
                                              </div>    
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.created_at}
                                              </Moment>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ),
                                ],
                              ]
                              : [
                                /* searched data, logic === haveData*/
                                searchedSupplier && [
                                  searchedSupplier.list.length === 0 ? (
                                    <tr className="align-middle">
                                      <td
                                        scope="row"
                                        colSpan="7"
                                        className="xsm-text align-middle text-center"
                                      >
                                        {_t(t("No data available"))}
                                      </td>
                                    </tr>
                                  ) : (
                                    searchedSupplier.list.map(
                                      (item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (goodReceiveList.current_page -
                                                  1) *
                                                  goodReceiveList.per_page}
                                            </th>

                                            <td className="xsm-text align-middle text-center">
                                              {item.document_identity}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.document_date}
                                              </Moment>
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.branch_name}
                                            </td>
                                          
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.supplier_name}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {currencySymbolLeft()}
                                              {formatPrice(item.net_amount)}
                                              {currencySymbolRight()}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.desc}
                                            </td>

                                            <td className="xsm-text text-capitalize font-weight-md align-middle text-center">
                                              {item.status === "Open" ? <span className="text-success">{item.status}</span> : (item.status === "Closed" ? <span className="text-danger">{item.status}</span> : <>{item.status}</>)}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <div className="d-flex justify-content-center"> 
                                                <button
                                                  className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                  onClick={()=>handleGetPrintData(item.id)}
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>
                                                {
                                                item.is_post !== 1 ? <>                                                   
                                                  <NavLink
                                                    className="btn btn-primary ml-2 rounded-sm"
                                                    to={`/dashboard/manage/stock/goods-received-note-dept-edit/${item.id}`}
                                                    style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                  >
                                                    <div className="d-flex align-items-center justify-content-center">
                                                      <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                    </div>
                                                  </NavLink>
                                                  <button
                                                    className="btn btn-danger ml-2 rounded-sm del-btn"
                                                    onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                  >                                                    
                                                    <MdDelete className="del-icon" />                                                    
                                                  </button>
                                                  <button
                                                    className="btn btn-dark ml-2 rounded-sm del-btn"
                                                    title="Post purchase" 
                                                    disabled={loading}  
                                                    style={{padding:"1px 0px 0px 1px"}}                                               
                                                    onClick={()=>handlePostApi(item.id)}
                                                  >
                                                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                  </button> </> : ""
                                                }
                                              </div>
                                            </td>
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.created_date}
                                              </Moment>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ),
                                ],
                              ]}
                          </tbody>
                        </table>
                      </div>
                    </div>                  
                </div>
              </div>
            </div>

            {/* pagination loading effect */}
            {loading === true
              ? paginationLoading()
              : [
                // logic === !searched
                !searchedSupplier.searched ? (
                  <div key="fragment4">
                    <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                      <div className="row align-items-center t-pl-15 t-pr-15">
                        <div className="col-md-7 t-mb-15 mb-md-0">
                          {/* pagination function */}
                          {pagination(
                            goodReceiveList,
                            setPaginatedGoodsRecieveNotes
                          )}
                        </div>
                        <div className="col-md-5">
                          <ul className="t-list d-flex justify-content-md-end align-items-center">
                            <li className="t-list__item">
                              <span className="d-inline-block sm-text">
                                {showingData(goodReceiveList)}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // if searched
                  <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                    <div className="row align-items-center t-pl-15 t-pr-15">
                      <div className="col-md-7 t-mb-15 mb-md-0">
                        <ul className="t-list d-flex">
                          <li className="t-list__item no-pagination-style">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                setSearchedSupplier({
                                  ...searchedSupplier,
                                  searched: false,
                                })
                              }
                            >
                              {_t(t("Clear Search"))}
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-5">
                        <ul className="t-list d-flex justify-content-md-end align-items-center">
                          <li className="t-list__item">
                            <span className="d-inline-block sm-text">
                              {searchedShowingData(
                                searchedSupplier,
                                goodReceiveListForSearch
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ),
              ]}
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
    <PurchaseOrderPrint
      name = "Goods Received Note"
      printDetailView={goodsNoteView}
      newRow={newRow}
      PrintView={componentRef}
    />
  </>
  )
}

export default GoodsReceivedNoteHistory
